<template>
  <v-container class="ari-pulse-policy-page container-wrapper">
    <v-row>
      <v-col class="ari-pulse-policy-page__header px-xl-0">
        <h1>ARI Pulse Terms of Use</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="ari-pulse-policy-page__content px-xl-0">
        <p>
          These Terms of Use apply specifically to ARI Pulse at
          <a href="https://www.ari.company/ari-pulse" target="_blank" rel="noopener noreferrer">https://www.ari.company/ari-pulse</a>.
          By accessing or using ARI Pulse, you agree to these Terms.
        </p>

        <h4>1. Provider</h4>
        <p>
          ARI Pulse is provided by <strong>Lidiia Dankevych, trading as ARI.company</strong>
          ("ARI.company", "we", "us", "our").
        </p>

        <h4>2. Service Description</h4>
        <p>
          ARI Pulse is a read-only SEO analytics utility built around Google Search Console data.
          It is intended to provide rapid performance snapshots, structured comparisons, and exportable report output.
        </p>

        <h4>3. Eligibility and Authority</h4>
        <p>
          You may only use ARI Pulse if you are legally able to enter into binding agreements and you are authorised
          to access the Google Search Console properties you connect.
        </p>

        <h4>4. Read-Only Nature of Access</h4>
        <p>
          ARI Pulse uses a read-only Google scope and does not provide functionality for publishing or editing your GSC data.
          You remain solely responsible for your own Google account, property permissions, and access controls.
        </p>

        <h4>5. User Responsibilities</h4>
        <p>By using ARI Pulse, you agree that you will:</p>
        <ul>
          <li>Provide accurate and lawful information where required.</li>
          <li>Use ARI Pulse only for legitimate business and analytics purposes.</li>
          <li>Not attempt to bypass security controls, automate abusive traffic, or disrupt service operations.</li>
          <li>Not reverse engineer, scrape, or misuse ARI Pulse infrastructure.</li>
        </ul>

        <h4>6. Reporting Modes and Comparisons</h4>
        <p>
          ARI Pulse may provide rolling-window and ISO-week comparison modes. Outputs are generated from third-party source data
          and depend on source availability, permissions, data latency, and API behaviour.
        </p>

        <h4>7. Exported Files</h4>
        <p>
          ARI Pulse may generate report exports (including XLSX). Once exported, storage, transfer, and internal handling
          of the file is your responsibility.
        </p>

        <h4>8. Availability and Changes</h4>
        <p>
          ARI Pulse is provided on an evolving basis. We may change, improve, limit, suspend, or discontinue features at any time,
          including temporarily for maintenance, security, or operational reasons.
        </p>

        <h4>9. No Warranties</h4>
        <p>
          ARI Pulse is provided on an "as is" and "as available" basis to the fullest extent permitted by applicable law.
          We do not warrant uninterrupted availability, complete error-free operation, or fitness for any specific legal,
          financial, compliance, or commercial purpose.
        </p>

        <h4>10. Limitation of Liability</h4>
        <p>
          To the extent permitted by law, ARI.company is not liable for indirect, incidental, consequential, special, or punitive damages,
          or for loss of revenue, profits, opportunities, data, or business arising from or related to the use of ARI Pulse.
        </p>

        <h4>11. Third-Party Services</h4>
        <p>
          ARI Pulse relies on third-party services (including Google APIs). Their terms, policies, uptime, and limitations apply independently.
          We are not responsible for third-party platform outages, policy changes, or access restrictions.
        </p>

        <h4>12. Privacy</h4>
        <p>
          Use of ARI Pulse is also governed by the dedicated
          <a href="/privacy-ari-pulse" target="_blank" rel="noopener noreferrer">ARI Pulse Privacy Policy</a>.
        </p>

        <h4>13. Governing Rules and Updates</h4>
        <p>
          These Terms may be updated periodically. The latest version published at this URL applies from its effective date.
          Continued use of ARI Pulse after updates means acceptance of the updated Terms.
        </p>

        <h4>14. Contact</h4>
        <p>
          For ARI Pulse legal or service-use questions, contact
          <a href="mailto:contact@ari.company">contact@ari.company</a>.
        </p>
        <p><i>Effective: April 7, 2026</i></p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'AriPulseTermsPage'
}
</script>

<style lang="scss" scoped>
.ari-pulse-policy-page {
  flex: 1 0 auto;

  &__header {
    padding-top: 60px;
  }

  &__content {
    padding-bottom: 60px;
    word-wrap: break-word;

    h4 {
      margin: 18px 0 10px;
    }

    p {
      font-size: 16px;
      margin-bottom: 12px;
    }

    ul {
      margin-bottom: 14px;
      color: $dark-text;
    }
  }
}
</style>
